<template>
  <figure v-lazyload class="image__wrapper" style="width: 100%">
    <img
      class="image__item"
      :data-url="source"
      :alt="name"
      style="width: 100%"
      :class="classes"
    >
  </figure>
</template>

<script>
export default {
  name: "image-item",

  props: {
    source: {
      type: String,
      required: true
    },
    name: {
      type: String,
      // required: true
    },
    classes: {
      type: String
    }
  }
};
</script>

<style lang="sass" scoped>
@import "@/assets/sass/home.sass"
</style>